export const red = {
    red100: '#fcf9f8',
    red200: '#fcf4f3',
    red300: '#fce7e4',
    red400: '#ffd7d0',
    red500: '#ffc8bf',
    red600: '#fcb7ad',
    red700: '#f4a296',
    red800: '#ec8779',
    red900: '#f04438',
    red1000: '#e23229',
    red1100: '#d01d19',
    red1200: '#621f19',
    redAccentContrast: '#ffffff',
    redAccentSurface: '#fdf5f3',
};

export const redAlpha = {
    red100: 'rgba(252, 99, 48, 0.02)',
    red200: 'rgba(252, 48, 23, 0.04)',
    red300: 'rgba(252, 38, 8, 0.1)',
    red400: '#ffd7d0',
    red500: '#ffc8bf',
    red600: 'rgba(252, 33, 1, 0.31)',
    red700: 'rgba(233, 32, 2, 0.41)',
    red800: 'rgba(221, 27, 0, 0.52)',
    red900: 'rgba(237, 17, 1, 0.78)',
    red1000: 'rgba(221, 11, 0, 0.84)',
    red1100: 'rgba(203, 4, 0, 0.9)',
    red1200: 'rgba(81, 7, 0, 0.9)',
    redAccentContrast: '#ffffff',
    redAccentSurface: 'rgba(253, 243, 241, 0.8)',
};

export const redDark = {
    red100: '#170f0e',
    red200: '#201412',
    red300: '#3b1410',
    red400: '#520f0b',
    red500: '#621611',
    red600: '#73241d',
    red700: '#8a2c2c',
    red800: '#a23535',
    red900: '#b93e3e',
    red1000: '#d14848',
    red1100: '#e95252',
    red1200: '#ff5c5c',
    redAccentContrast: '#ffffff',
    redAccentSurface: '#1d1610',
};

export const redDarkAlpha = {
    red100: 'rgba(20, 16, 13, 0.01)',
    red200: 'rgba(29, 22, 16, 0.04)',
    red300: 'rgba(51, 17, 17, 0.11)',
    red400: 'rgba(74, 26, 26, 0.18)',
    red500: 'rgba(94, 31, 31, 0.24)',
    red600: 'rgba(115, 37, 37, 0.31)',
    red700: 'rgba(138, 44, 44, 0.38)',
    red800: 'rgba(162, 53, 53, 0.45)',
    red900: 'rgba(185, 62, 62, 0.7)',
    red1000: 'rgba(209, 72, 72, 0.65)',
    red1100: 'rgba(233, 82, 82, 0.83)',
    red1200: 'rgba(255, 92, 92, 0.96)',
    redAccentContrast: '#ffffff',
    redAccentSurface: 'rgba(29, 22, 16, 0.5)',
};
